// extracted by mini-css-extract-plugin
module.exports = {"TDA_RIGHT_BOX_NAV":"TDA_RIGHT_BOX_NAV--168p_","TDA_RIGHT_BOX_NAV_TEXT":"TDA_RIGHT_BOX_NAV_TEXT--2bY_e"};